export const getIsActive = state => state.isActive
export const getName = state => state.name
